// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zi65","label":"styles_label__2ec8j"};